export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

// for getting proper owner of genkai and vxs those are added here
// it is actuall RONIN_V3_PROXY
export const RONIN_GATEWAY_V2_ADDRESS = '0x0cf8ff40a508bdbc39fbe1bb679dcba64e65c7df';
export const RONIN_GATEWAY_V2_ADDRESS_TESTNET = '0xcee681c9108c42c710c6a8a949307d5f13c9f3ca';

export const MAX_ALLOWANCE = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';
